module.exports = __webpack_public_path__ + "img/buba_no.ecbeb7b7.png";